import { Group, InputWrapperProps, Radio, RadioGroupProps, Stack } from "@mantine/core";
import { useFormHelperContext } from "../form";
import { useEffect, useState } from "react";
import { InputWrapper } from "../inputWrapper";

interface CheckboxOption {
    label: string;
    value: string;
}
export interface FieldInputRadioProps extends Omit<RadioGroupProps, "children"> {
    error?: string;
    options: CheckboxOption[];
    label: string;
    name: string;
    inputWrapper?: InputWrapperProps;
    styleRadioVertical?: boolean;
}


export const FieldInputRadio: React.FC<FieldInputRadioProps> = ({ options, label, inputWrapper, name, styleRadioVertical, ...rest }) => {
    const { register, formStore, getValues, setValue, formState } = useFormHelperContext()
    if (!register) {
        throw new Error("Field.Text must be used within a FormHelper component");
    }
    const errors = (formState.errors[`${name}`] as any)
    const currentValue = getValues(name)
    const [currentValueState, setCurrentValueState] = useState(currentValue)
    useEffect(() => {
        setCurrentValueState(currentValue)
    }, [currentValue])
    return (
        <InputWrapper label={label} {...inputWrapper} withAsterisk={rest.withAsterisk}>
            <div className="flex flex-grow">
                <Radio.Group
                    name={name}
                    value={currentValueState}
                    onChange={e => {
                        setValue(name, e)
                        setCurrentValueState(e)
                    }}
                    data-testid={'field-radio-group-' + name}
                    readOnly={formStore.readOnly}
                    {...rest}
                    error={errors?.message || ''}
                >
                    {!styleRadioVertical && (
                        <Group>
                            {options.map((option, index) => {
                                return (
                                    <Radio value={option.value} label={option.label} key={index} checked  data-testid={'field-radio-option-' + name} />)
                            })}
                        </Group>
                    )}

                    {styleRadioVertical && (
                        <Stack>
                            {options.map((option, index) => {
                                return (
                                    <Radio value={option.value} label={option.label} key={index} checked data-testid={'field-radio-option-' + name} />)
                            })}
                        </Stack>
                    )}
                </Radio.Group>
            </div>
        </InputWrapper>
    )


}
